var exports = {
  "kL": "SettingsTabLayout.module__container___MEMyLU",
  "Qs": "SettingsTabLayout.module__content___MEMyLU",
  "mK": "SettingsTabLayout.module__subsection___MEMyLU",
};

module.exports = exports;
